import axios, { AxiosResponse } from 'axios';

const reprintUrl = `${process.env.VUE_APP_ROOT_API}/Reprint`;

export const ReprintService = {
  GetReprintReasons(): Promise<AxiosResponse> {
    return axios.get(`${reprintUrl}/GetReprintReasons`);
  }
};
